function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24" {...props}><path d="M16.5 8.333c0 3.468-2.1 6.5-4.5 6.5s-4.5-3.032-4.5-6.5C7.5 4.67 9.077 2.5 12 2.5s4.5 2.169 4.5 5.833zM4 21.5a.5.5 0 0 1-.5-.5c0-5.453 2.805-7.167 8.5-7.167s8.5 1.714 8.5 7.167a.5.5 0 0 1-.5.5z" /></svg>;
});